import { Heading } from '@big-red-group/storefront-common-ui'
import { SearchWrapper, Wrapper, IconWrapper } from './HomeHero.styles'
import { UnderlineGraphic } from '@/components/Icons.styles'
import Icon from '@/components/Icons'
import SearchTemplateBox from './SearchTemplateBox'

import { useContext } from 'react'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'
import { TopbarConfigurationDestination } from '@/types'

const HomeHero: React.FC<{
  title: string
  subtitle: string
  image: string
  destinations: TopbarConfigurationDestination[]
}> = ({ title, subtitle, image, destinations }) => {
  const defaultProperties = useContext(DefaultPropertiesContext)
  const agentHandlerKey = defaultProperties?.agentConfiguration?.handlerKey

  return (
    <Wrapper data-mcp-id="home-hero" image={image}>
      {title && (
        <Heading size="XXL" as="h1">
          {title}
          <UnderlineGraphic bottomOffset={'-22px'}>
            <Icon name="underline" width={76} height={7} fill="#FAC532" />
          </UnderlineGraphic>
        </Heading>
      )}
      <Heading size="S" balanced>
        {subtitle}
      </Heading>
      <SearchWrapper>
        {/* TODO: props are blank because the home search box never needs to display what was searched for */}
        <SearchTemplateBox
          destinations={destinations}
          part1Type={''}
          part2Type={''}
          part1={''}
          part2={''}
          part3={''}
          lang={''}
        />
      </SearchWrapper>
      {/* Velocity points campaign */}
      {agentHandlerKey === 'virgin' && (
        <IconWrapper>
          <Icon name="velocityCampaign" />
        </IconWrapper>
      )}
    </Wrapper>
  )
}

export default HomeHero
